"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FinanceBreakDownViews;
(function (FinanceBreakDownViews) {
    FinanceBreakDownViews["FULL"] = "full";
    FinanceBreakDownViews["BREAKDOWN"] = "breakdown";
})(FinanceBreakDownViews = exports.FinanceBreakDownViews || (exports.FinanceBreakDownViews = {}));
